export const amber = {
  50: 'hsla(46, 100%, 94%, 1)',
  800: 'hsla(34, 100%, 50%, 1)',
};

export type AmberPalette = typeof amber;
